export interface SubmitConfirmDisclosureContentRequest {
    /** 任务ID */
    task_id: string;
    /** 分类号 */
    classification?: string[];
    /** 类型 */
    category?: string;
    /** 技术问题 */
    technical_problem?: string;
    /** 技术手段 */
    technical_methods?: string;
    /** 功效 */
    benefit?: string;
    /** 实施例 */
    embodiments?: {
        text: string;
        selected: boolean;
    }[];
}

export interface SubmitConfirmDisclosureContentResponse {
}

export const SubmitConfirmDisclosureContentApi = Symbol.for('SubmitConfirmDisclosureContentApi');

export interface SubmitConfirmDisclosureContentApi {
    submitConfirmDisclosureContent(data: SubmitConfirmDisclosureContentRequest): Promise<SubmitConfirmDisclosureContentResponse>;
}
